// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1ab3H","Label":"Input_Label__1h0ZG","InputElement":"Input_InputElement__1RmDy","Invalid":"Input_Invalid__4xgXM"};